module.exports = __webpack_public_path__ + "static/media/TFORK.9fb45940.svg";